export const INVESTMENT_HORIZON_OPTIONS = [
    { value: 'IMMEDIATE', label: 'Immediate' },
    { value: 'CURRENT_BUDGET_CYCLE', label: 'Current Budget Cycle' },
    { value: 'MULTI_YEAR', label: 'Multi-year' }
]

export const DELIVERY_CAPACITY_OPTIONS = [
    { value: 'LIMITED', label: 'Limited' },
    { value: 'MODERATE', label: 'Moderate' },
    { value: 'HIGH', label: 'High' }
]

// Reuse existing governed appetite terminology from Decision Center and Portfolio Analysis surfaces.
export const RISK_APPETITE_OPTIONS = [
    { value: 'COMPLIANT', label: 'Compliant' },
    { value: 'OUTSIDE_RISK_APPETITE', label: 'Outside appetite' },
    { value: 'POLICY_UNAVAILABLE', label: 'Policy unavailable' }
]

export const EXECUTIVE_CONSTRAINT_FIELDS = ['availableCapital', 'investmentHorizon', 'deliveryCapacity', 'riskAppetite']

export const createExecutiveConstraintsState = () => ({
    availableCapital: '',
    investmentHorizon: '',
    deliveryCapacity: '',
    riskAppetite: ''
})

export const findConstraintLabel = (options, value) => options.find((option) => option.value === value)?.label || ''

export const missingExecutiveConstraints = (constraints) =>
    EXECUTIVE_CONSTRAINT_FIELDS.filter((field) => constraints?.[field] == null || constraints[field] === '')
